<div class="proposal-details-wrapper h-100" *ngIf="!is_loading">
    <div class="prposal-inner h-100 overflow-hidden">
        <div class="proposal-header d-flex justify-content-between align-items-center  px-3 py-2 bg-white">
            <span class="d-flex align-items-center">
                <img src="assets/images/icons/back-arrow-circle.svg" alt="" class="hw-32 me-3 cursor"
                    [routerLink]="'/app/disputes'" >
                <p class="fs-16 fw-600 m-0" style="font-size: 16px;font-weight: 500;">
                    Dispute details
                </p>
            </span>
        </div>
        <div class="proposal-body position-relative overflow-hidden">
            <ng-template #noImage>
                <img src="assets/images/icons/credit-meter.svg" alt="" class="me-2">
            </ng-template>

            <div class="inner-body h-100 overflow-auto bg-white -p-5" *ngIf="contract_data">
                <div class="p-3 -text-center pt-5 position-relative d-flex align-items-end">
                    <span class="gradient-img position-absolute top-0  end-0 w-100"></span>
                    <!-- <img src="assets/images/icons/profile_placeholder.png" alt=""
                                        class="hw-80 rounded-circle borfde mb-3 cursor mt-2 border-white"> -->
                    <img *ngIf="contract_data && contract_data['profile_image']" [src]="contract_data['profile_image']"
                        alt="" class="ZI-2 hw-80 rounded-circle borfde mb-3 cursor mt-2 border-white">
                    <span
                        [style]="{'background-color': _shared.dynamicColorBgStyle[_shared.randomIndex]['bg'], 'color': _shared.dynamicColorBgStyle[_shared.randomIndex]['color']}"
                        *ngIf="contract_data && !contract_data['profile_image']"
                        class="ZI-2 hw-95 -mx-auto d-flex align-items-center justify-content-center rounded-circle borfde mb-3 cursor mt-2 border-white fs-24 fw-700" style="font-size: 24px;font-weight: 600;">{{initials}}
                    </span>
                    <div class="d-flex flex-fill align-items-center justify-content-between">


                        <div class="ps-3">
                            <h4 class="fs-20 fw-800 text-capitalize " style="font-size: 20px;font-weight: 700;">
                                {{contract_data.patient_first_name + ' ' + contract_data.patient_last_name}}
                            </h4>
                            <p class="fs-16 fw-500" style="font-size: 16px;font-weight: 400;">
                                {{contract_data.patient_email}} | {{contract_data.patient_mobile_country_code}}
                                <input type="text" [ngModel]="contract_data?.patient_mobile" [mask]="mask"
                                    class="pe-none mxw-140 bg-transparent border-0">
                            </p>
                        </div>
                        <!-- <span class="py-1 px-3 rounded-pill border bg-success text-white">
                        hagsdf
                    </span> -->

                        <!-- <p class="fs-16 fw-600 grey-126 m-0 me-3">
                            <span class="prposal-status fs-16 fw-600 m-0 px-3 py-1 rounded-pill text-capitalize"
                                [ngClass]="is_pending  ? 'pending2' : is_submitted ?  'submitted2' : is_verified ? 'verified2' : need_more_documents ? 'need-doc2' : 'new2'">

                                {{is_pending ? 'Pending' : is_submitted ? 'Submitted' : is_verified ? 'Verified' :
                                need_more_documents ? 'Need Document' : 'New'
                                }}
                            </span>
                        </p> -->
                    </div>
                    <hr class="mx-3">
                </div>
                <div class="dispute-container">
                    <div class="documents-section">
                        <h3 class="section-title">Required Documents</h3>
                        <p class="file-info">Max file size: 10MB | Supported files: pdf, png, jpeg, jpg</p>
                        <div class="document-item " *ngFor="let document of contract_documents">
                        <span class="document-icon">
                            <img [src]="!document.doc_url ? 'assets/images/icons/file-minus-03.svg' : !document.doc_url.includes('.pdf') ? 'assets/images/icons/image-icon-small.png' : 'assets/images/icons/PDF_file_icon.png'"></span>
                        <span class="document-name">{{ document.document_name }} <br>
                            <span *ngIf="document.need_more_documents && document.need_doc_reason" class="text-danger fs-14 fw-600">{{document.need_doc_reason}}</span>
                        </span>
                            
                            <div class="doc-url me-2" *ngIf="document.doc_url && document.is_uploaded">
                            
                                <a [href]="document.doc_url " target="_blank">
                                    <img src="assets/images/icons/open-eye.svg" tappable tooltip="View Document">
                                </a>
                            </div>
                            <!-- <label *ngIf="!document.doc_url || document.need_more_documents"
                                                            [for]="'images'+document.document_type_id" class="btn"
                                                            style="color: #0046AF;">Upload</label>
                                                        <input *ngIf="!document.doc_url || document.need_more_documents" type="file" name=""
                                                            [id]="'images'+document.document_type_id" #imageElement accept=".jpeg, .jpg, .png, .pdf"
                                                            (change)="fileSelect(true, document)" class="d-none"> -->
                            <p class="fs-16 fw-600  mb-3 mt-3 me-2 text-primary cursor" style="font-size: 16px;font-weight: 500;" *ngIf="!document.doc_url || (document.need_more_documents && !document.is_uploaded) || (document.need_more_documents && !document.is_reupload)"
                                (click)="fileSelect(false, document)">
                                Upload
                            </p>
                            <span *ngIf="document.doc_url && document.is_verified !== 1 && document.is_submitted !== 1 && !document.need_more_documents || (document.need_more_documents && document.is_uploaded && document.is_reupload) "
                                class="cross hw-32 need-doc2 d-flex  justify-content-center rounded-circle borfde  cursor  border-white fs-14 fw-500 bg-lightgrey" (click)="deleteDocument(document.document_id)">
                                x
                            </span>

                        </div>

                        <p class="fs-16 fw-600   mt-3 text-primary cursor" style="font-size: 16px;font-weight: 500;"
                            (click)="showDocumentUploadModal(true,-1)"
                            *ngIf="!need_more_documents && !is_verified">
                            + Add More Documents
                        </p>
                        <!-- *ngIf="need_more_documents || !is_verified" -->
                        <div class="mt-4">
                            <label for="note">Enter Note</label>
                        <textarea class="note-input  " id="note" [(ngModel)]="doc_note"></textarea>
                        </div>                       

                        <!-- *ngIf="need_more_documents || !is_verified" -->
                        <button class="btn btn-secondary mb-5" (click)="submitDocuments()" 
                            [disabled]="!is_any_doc_upload || !doc_count">Submit</button>

                    </div>

                    <div class="disputes-section">
                        <h3 class="section-title">{{disputedPayments.length}} Payments Disputed</h3>

                        <div class="dispute-card" *ngFor="let dispute of disputedPayments">
                            <p class="amount-label m-0">Amount Disputed</p>
                            <p class="amount-value">${{ dispute.amount_disputed | number:'1.2-2'}}</p>
                            <p class="payment-type m-0">Payment Type:</p>
                            <p class="payment-value ">{{ dispute.payment_type }}</p>
                            <p class="disputed-date">Disputed date: {{ dispute.dispute_date | date:"MM/dd/yyyy" :
                                timezone }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <div class="h-100 w-100" *ngIf="!is_loading">
loading
</div> -->